import { axiosHub } from '../config/axiosHub.config'

export type WorkflowDTO = {
  id: string
  title: string
  ticketsCount: number
}

export type WorkflowSearchParams = {
  organizationId: string
  search?: string
  limit?: number
}

const getWorkflows = async (params: WorkflowSearchParams): Promise<WorkflowDTO[]> => {
  const { data } = await axiosHub.get<WorkflowDTO[]>('/api/v1/crm/workflows', {
    params
  })
  return data
}

export const Workflow = {
  getWorkflows
} 